function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_442",
  "data-name": "Path 442",
  d: "M44.327,59.3H5.7A5.7,5.7,0,0,0,0,65V92.04a5.7,5.7,0,0,0,5.7,5.7H44.337a5.7,5.7,0,0,0,5.7-5.7V65A5.717,5.717,0,0,0,44.327,59.3ZM3.654,68.572V64.986a2.031,2.031,0,0,1,2.032-2.032H44.327a2.031,2.031,0,0,1,2.032,2.032v3.586Zm40.673,25.51H5.7a2.031,2.031,0,0,1-2.032-2.032V72.236H46.379V92.049A2.06,2.06,0,0,1,44.327,94.082Z",
  transform: "translate(0 -59.3)",
  fill: "#868eae"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_443",
  "data-name": "Path 443",
  d: "M284.9,259H272.532a1.632,1.632,0,0,0,0,3.263H284.9a1.632,1.632,0,1,0,0-3.263Z",
  transform: "translate(-244.433 -239.489)",
  fill: "#868eae"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_444",
  "data-name": "Path 444",
  d: "M327.76,338.1h-7.728a1.632,1.632,0,1,0,0,3.263h7.728a1.632,1.632,0,1,0,0-3.263Z",
  transform: "translate(-287.292 -310.861)",
  fill: "#868eae"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Path_445",
  "data-name": "Path 445",
  d: "M91.613,259.479A1.643,1.643,0,0,0,90.46,259H82.732a1.634,1.634,0,0,0-1.632,1.632v7.728a1.634,1.634,0,0,0,1.632,1.632H93.547a1.635,1.635,0,0,0,1.632-1.632v-4.641a1.586,1.586,0,0,0-.479-1.153Zm.3,4.924v2.325H84.363v-4.455h5.422Z",
  transform: "translate(-73.176 -239.489)",
  fill: "#868eae"
});

var Svg155CreditCard = function Svg155CreditCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_155-credit-card",
    "data-name": "155-credit-card",
    width: 50.033,
    height: 38.436,
    viewBox: "0 0 50.033 38.436",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg155CreditCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/155-credit-card.c1183601.svg";
export { ForwardRef as ReactComponent };